var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20 7C20 9.20914 16.4183 11 12 11C7.58172 11 4 9.20914 4 7C4 4.79086 7.58172 3 12 3C16.4183 3 20 4.79086 20 7Z",
    fill: "#048290"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.75 13.4766C19.3141 14.0925 18.6191 14.6267 17.7687 15.052C16.2794 15.7966 14.2395 16.25 12 16.25C9.76047 16.25 7.72059 15.7966 6.23134 15.052C5.38086 14.6267 4.68587 14.0925 4.25 13.4766V17C4.25 17.9588 5.03381 18.8942 6.45495 19.6048C7.86113 20.3079 9.82126 20.75 12 20.75C14.1787 20.75 16.1389 20.3079 17.5451 19.6048C18.9662 18.8942 19.75 17.9588 19.75 17V13.4766Z",
    fill: "#048290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 7C20 9.20914 16.4183 11 12 11C7.58172 11 4 9.20914 4 7C4 4.79086 7.58172 3 12 3C16.4183 3 20 4.79086 20 7Z",
    stroke: "#048290",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12C20 14.2091 16.4183 16 12 16C7.58172 16 4 14.2091 4 12",
    stroke: "#048290",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7V17C4 19.2091 7.58172 21 12 21C16.4183 21 20 19.2091 20 17V7",
    stroke: "#048290",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.509011c0390718f7b6898706948174f0.svg";
export { ForwardRef as ReactComponent };